<template>
  <g fill="none" fill-rule="evenodd">
    <g>
      <g>
        <g>
          <path
            fill="#4A85D3"
            d="M0 16.949C0 7.588 7.587 0 16.948 0c9.36 0 16.947 7.588 16.947 16.949 0 9.358-7.588 16.946-16.947 16.946C7.588 33.895 0 26.307 0 16.949"
            transform="translate(-30 -1699) translate(26 1695) translate(4.108 4.108)"
          />
          <path
            fill="#407EC1"
            d="M25.814 2.483c1.688 2.634 2.666 5.767 2.666 9.129 0 9.359-7.587 16.946-16.948 16.946-3.249 0-6.287-.914-8.866-2.501 3.013 4.702 8.284 7.818 14.282 7.818 9.36 0 16.947-7.587 16.947-16.948 0-6.108-3.233-11.462-8.08-14.444"
            transform="translate(-30 -1699) translate(26 1695) translate(4.108 4.108)"
          />
          <path
            fill="#5B9ADD"
            d="M2.304 18.736c0-8.69 7.045-15.735 15.734-15.735 5.08 0 9.595 2.407 12.473 6.143-2.716-4.717-7.809-7.893-13.644-7.893-8.69 0-15.736 7.045-15.736 15.735 0 3.611 1.22 6.937 3.263 9.592-1.33-2.309-2.09-4.987-2.09-7.842"
            transform="translate(-30 -1699) translate(26 1695) translate(4.108 4.108)"
          />
          <path
            fill="#FFF"
            d="M26.713 12.942h-5.884c-.149 0-.262-.143-.222-.286.24-.85.26-1.77.26-2.64 0-.482.024-1.027-.03-1.553-.053-.536-.184-1.05-.5-1.457-.35-.452-.872-.789-1.45-.789-1.344 0-1.557 1.317-1.682 2.384-.147 1.245-.205 2.532-.754 3.679-.386.803-.932 1.493-1.79 1.831-.657.26-1.143.463-1.836.599-.108.02-.185.113-.185.222v8.7c0 .126.101.228.228.228h2.406c.074 0 .141.038.185.095.475.637 1.233 1.05 2.09 1.05h7.54c1.1 0 2.002-.9 2.002-2.002 0-.284-.07-.553-.191-.791-.048-.096-.024-.211.06-.277.407-.326.671-1.068.671-1.628v-.229c0-.284-.07-.553-.19-.793-.048-.094-.022-.209.06-.277.409-.324.671-.823.671-1.383v-.23c0-.283-.067-.554-.189-.792-.047-.096-.023-.211.06-.277.408-.324.67-.825.67-1.384 0-1.101-.899-2-2-2M10.868 24.75H7.317c-.3 0-.545-.244-.545-.544v-9.934c0-.3.245-.545.545-.545h3.551c.302 0 .547.245.547.545v9.934c0 .3-.245.545-.547.545"
            transform="translate(-30 -1699) translate(26 1695) translate(4.108 4.108)"
          />
        </g>
      </g>
    </g>
  </g>
</template>
<script>
export default {
  props: {
    color: {
      type: String,
      default: 'currentColor',
    },
  },
};
</script>
